import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=3210d29e&scoped=true&"
import script from "./SortableList.vue?vue&type=script&lang=ts&"
export * from "./SortableList.vue?vue&type=script&lang=ts&"
import style0 from "./SortableList.vue?vue&type=style&index=0&id=3210d29e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3210d29e",
  null
  
)

export default component.exports